// extracted by mini-css-extract-plugin
export var browser = "BrowserMockup-module--browser--SU1U4";
export var addressBar = "BrowserMockup-module--address-bar--gSy2j";